export default __webpack_public_path__ + "static/media/default-503.b257641e.svg";